// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Ngji","fullView":"styles_fullView__3CBhJ"};